export default{
  collections: state => state.collections,
  collection: state => state.collection,
}